import { add, normalize, scale, subtract } from './math.js';
export const RAIDER_FIRE = {
    aimMs: 700, cooldownMs: 2400, range: 58, speed: 70, damage: 16,
    playerRadius: 0.55,
    rifleSide: 0.22, rifleHeight: 0.32, rifleForward: 0.1, barrelLength: 0.95,
};
/** Shared rifle pivot and muzzle keep rendered gunfire on the authoritative trajectory. */
export function raiderAimPose(source, destination) {
    const yaw = Math.atan2(source.x - destination.x, source.z - destination.z);
    const pivot = {
        x: source.x + Math.cos(yaw) * RAIDER_FIRE.rifleSide - Math.sin(yaw) * RAIDER_FIRE.rifleForward,
        y: source.y + RAIDER_FIRE.rifleHeight,
        z: source.z - Math.sin(yaw) * RAIDER_FIRE.rifleSide - Math.cos(yaw) * RAIDER_FIRE.rifleForward,
    };
    // Aim the separate rifle rig exactly at the target, including its shoulder offset.
    const direction = normalize(subtract(destination, pivot));
    const rifleYaw = Math.atan2(-direction.x, -direction.z) - yaw;
    const pitch = Math.atan2(direction.y, Math.hypot(direction.x, direction.z));
    return { yaw, rifleYaw, pitch, muzzle: add(pivot, scale(direction, RAIDER_FIRE.barrelLength)) };
}
export function enemyProjectilePosition(projectile, now) {
    const travel = Math.max(0, Math.min(now, projectile.expiresAt) - projectile.firedAt) * RAIDER_FIRE.speed / 1000;
    return add(projectile.origin, scale(normalize(subtract(projectile.destination, projectile.origin)), travel));
}
//# sourceMappingURL=enemy-fire.js.map